module.exports = __webpack_public_path__ + "5fd783560fdfaabe.svg";